"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Services = _interopRequireDefault(require("../Services"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Ekvalayzer1 = function Ekvalayzer1(props) {
  return _react.default.createElement("div", {
    className: "sl-ekvalayzer"
  }, _react.default.createElement("div", {
    className: "sl-loader-items",
    style: {
      "--size": _Services.default.getZoom(props.size || 100)
    }
  }, _react.default.createElement("div", {
    className: "sl-parent-rectangular"
  }, _react.default.createElement("div", {
    className: "sl-rectangular",
    style: {
      "--bg": props.bgColor || "#FFFFFF",
      "--w": 2,
      "--i": 1
    }
  })), _react.default.createElement("div", {
    className: "sl-parent-rectangular"
  }, _react.default.createElement("div", {
    className: "sl-rectangular",
    style: {
      "--bg": props.bgColor || "#FFFFFF",
      "--w": 1,
      "--i": 0
    }
  })), _react.default.createElement("div", {
    className: "sl-parent-rectangular"
  }, _react.default.createElement("div", {
    className: "sl-rectangular",
    style: {
      "--bg": props.bgColor || "#FFFFFF",
      "--w": 2,
      "--i": 1
    }
  })), _react.default.createElement("div", {
    className: "sl-parent-rectangular"
  }, _react.default.createElement("div", {
    className: "sl-rectangular",
    style: {
      "--bg": props.bgColor || "#FFFFFF",
      "--w": 1,
      "--i": 2
    }
  })), _react.default.createElement("div", {
    className: "sl-parent-rectangular"
  }, _react.default.createElement("div", {
    className: "sl-rectangular",
    style: {
      "--bg": props.bgColor || "#FFFFFF",
      "--w": 2,
      "--i": 1
    }
  })), _react.default.createElement("div", {
    className: "sl-parent-rectangular"
  }, _react.default.createElement("div", {
    className: "sl-rectangular",
    style: {
      "--bg": props.bgColor || "#FFFFFF",
      "--w": 1,
      "--i": 0
    }
  })), _react.default.createElement("div", {
    className: "sl-parent-rectangular"
  }, _react.default.createElement("div", {
    className: "sl-rectangular",
    style: {
      "--bg": props.bgColor || "#FFFFFF",
      "--w": 2,
      "--i": 2
    }
  }))), props.title !== undefined ? _react.default.createElement("div", {
    className: "sl-loader-title",
    style: {
      "--cl": props.color || "#FFFFFF"
    }
  }, _react.default.createElement("span", null, props.title)) : null);
};

var _default = Ekvalayzer1;
exports.default = _default;